import Type, { Body } from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';
import Image from '@nerdwallet/react-image';
import { CenteredContainer } from '@nerdwallet/react-layout';

const badge =
  'https://www.nerdwallet.com/cdn/NW-awards/2020/hero/NW-awards-badge.png';
const badgeFull =
  'https://www.nerdwallet.com/cdn/NW-awards/2021/homepage/BOA-full-badge@2x-v3.png';
const ctaText = 'see all the winners';
const ctaLink = '/awards?trk=hpboabanner';
const ctaDescription =
  "Behold the power of nerdy research. Check out your shortcut to this year's best credit cards, banks and more.";

const BoABanner = () => {
  return (
    <CenteredContainer className="best-of-section">
      <div className="best-of-container">
        <div className="left-side">
          <div className="best-of-icon-container">
            <Image
              src={badgeFull}
              alt=""
              className="best-of-badge-icon-full"
              backgroundColor="transparent"
              naturalWidth={70}
              naturalHeight={93}
            />
          </div>
          <div className="best-of-icon-container-mobile">
            <Image
              src={badge}
              alt=""
              className="best-of-badge-icon"
              backgroundColor="transparent"
              naturalWidth={40}
              naturalHeight={50}
            />
          </div>
          <div className="title-container">
            <div className="text-container">
              <Type size="4" uppercase className="best-of-banner-text">
                Best-Of
              </Type>
              <Type size="4" uppercase className="best-of-banner-text">
                Awards
              </Type>
            </div>
            <Type size="4" italic className="best-of-banner-year">
              2021
            </Type>
          </div>
        </div>
        <div className="best-of-divider" />
        <div className="right-side">
          <Body className="cta-description">{ctaDescription}</Body>
          <Button href={ctaLink} className="best-of-cta" primary={false}>
            {ctaText}
          </Button>
        </div>
      </div>
    </CenteredContainer>
  );
};

export default BoABanner;
